/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from "moment";
import * as types from "./types";

export const state = {
  list: [],
  summary: { month_transacted: 0, devices_count: 0, establishments_count: 0 },
  categoriesList: [],
  getCep: {},
  partner: {},
  filtersInitialDate: moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  filtersFinalDate: moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  filtersPartnerInitialDate: moment()
    .startOf("year")
    .format("YYYY-MM-DD"),
  filtersPartnerFinalDate: moment()
    .add(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD"),
  filtersCardBrand: "",
  filtersTerminalNumber: "",
  filtersStatus: "",
  filtersAccountType: "",
  filtersPartner: "",
  filterStatus: false,
  filtersName: "",
  filtersOperation: "",
  filtersOrdination: "",
  limitOptions: [10, 25, 50, 100],
  limit: 10,
  page: 1,
  totalResources: 0,
  actived: false,
  isLoad: false,
  activeNew: false,
  toggleTaxForm: false,
  account: {},
  showError: false,
  showSuccess: false,
  showConfirm: false,
  showCancel: false,
  showFilters: false,
  errors: {},
  loadingData: false,
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_created_at_between: {
        start_at: null,
        end_at: null,
      },
      with_name: null,
      account_type: null,
      with_partner: null,
      partner: null,
      sorted_by: null
    },
  }
};

export const mutations = {
  [types.LIST](state, list) {
    state.list = list;
  },
  [types.SET_SUMMARY](state, summary) {
    state.summary = {
      month_transacted: Number(summary.month_transacted) || 0,
      devices_count: Number(summary.devices_count) || 0,
      establishments_count: Number(summary.establishments_count) || 0,
    };
  },
  [types.LIST_CATEGORIES](state, categoriesList) {
    state.categoriesList = categoriesList;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LIMIT](state, param) {
    state.limit = param;
    // state.filterParams.limit = param;
  },
  [types.PAGE](state, param) {
    state.page = param;
    state.filterParams.page = param;
  },
  [types.ACTIVED](state, actived) {
    state.actived = actived;
  },
  [types.IS_LOAD](state, isLoad) {
    state.isLoad = isLoad;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.ACTIVE_NEW](state, activeNew) {
    state.activeNew = activeNew;
  },
  [types.TOGGLE_TAX_FORM](state, toggleTaxForm) {
    state.toggleTaxForm = toggleTaxForm;
  },
  [types.ACCOUNT](state, account) {
    state.account = account;
  },
  [types.SHOW_ERROR](state, showError) {
    state.showError = showError;
  },
  [types.ERRORS](state, errors) {
    state.errors = errors;
  },
  [types.SHOW_SUCCESS](state, showSuccess) {
    state.showSuccess = showSuccess;
  },
  [types.SHOW_CONFIRM](state, showConfirm) {
    state.showConfirm = showConfirm;
  },
  [types.SHOW_CANCEL](state, showCancel) {
    state.showCancel = showCancel;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.SET_PARTNER_DATA](state, partner) {
    state.partner = partner;
  },
  [types.SET_CEP_DATA](state, data) {
    state.getCep = data;
  },
  [types.SET_FILTER_PARTNER_INITIAL_DATE](state, date) {
    state.filtersPartnerInitialDate = date;
  },
  [types.SET_FILTER_PARTNER_FINAL_DATE](state, date) {
    state.filtersPartnerFinalDate = date;
  },
  [types.SET_FILTER_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SET_FILTER_NAME](state, status) {
    state.filtersStatus = status;
  },
  [types.SET_FILTER_ACCOUNT_TYPE](state, type) {
    state.filtersAccountType = type;
  },
  [types.SET_FILTER_PARTNER](state, partner) {
    state.filtersPartner = partner;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_TOTAL_RESOURCES](state, param) {
    state.totalResources = param;
  },
};
